import React from 'react'
import createIcon from '@/lib/create-icon'

export const ServerIcon = createIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2002_19431)">
      <path d="M16.6665 1.66699H3.33317C2.4127 1.66699 1.6665 2.41318 1.6665 3.33366V6.66699C1.6665 7.58747 2.4127 8.33366 3.33317 8.33366H16.6665C17.587 8.33366 18.3332 7.58747 18.3332 6.66699V3.33366C18.3332 2.41318 17.587 1.66699 16.6665 1.66699Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.6665 11.667H3.33317C2.4127 11.667 1.6665 12.4132 1.6665 13.3337V16.667C1.6665 17.5875 2.4127 18.3337 3.33317 18.3337H16.6665C17.587 18.3337 18.3332 17.5875 18.3332 16.667V13.3337C18.3332 12.4132 17.587 11.667 16.6665 11.667Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2002_19431">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
